export const API_BASE_URL = 'https://serenity.medista.ai:9030';